// import React from 'react';
// import HeroVid from '../../components/Main/HeroVid';
// import Activities from '../../components/Main/Activities';
// import MainCarousel from '../../components/Main/MainCarousel';
// import MainFacilities from '../../components/Main/MainFacilities';
// // import Instagram from '../../components/Instagram';
// import Ads from '../../components/Main/Ads';


// function index() {
//   return (
//     <>
//         <HeroVid/>
//         <Activities />
//         <MainCarousel />
//         <MainFacilities />
//         {/* <Instagram /> */}
//         <Ads />
//     </>
//   )
// }

// export default index

// import React, { useState } from 'react';
import React, { useState, useEffect} from 'react';// ✅ ADDED
import HeroVid from '../../components/Main/HeroVid';
import Activities from '../../components/Main/Activities';
import NewMainCarousel from '../../components/Main/NewMainCarousel';
import HomeNews from '../../components/Main/HomeNews';
import HomeMembership from '../../components/Main/HomeMembership';
import HomeMembershipForm from '../../components/Inquiry/index';
import HomeEvents from '../../components/Events/index';
import AboutUs from '../../components/Main/AboutUs';
// import Ads from '../../components/Main/Ads';
import { useLocation } from 'react-router-dom'; 

// ✅ IMPORT LOGIN POPUP
// import LoginPopup from '../../components/LogIn/LoginPopup';

function Index() {
  
  const { hash } = useLocation();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100); 
        }
      }
    }, [hash]);
    
  return (
    <>
     


      {/* ✅ EXISTING HOMEPAGE CONTENT */}
      <HeroVid setCurrentIndex={setCurrentIndex} />
      <Activities />
      <NewMainCarousel 
        currentIndex={currentIndex} 
        setCurrentIndex={setCurrentIndex}/>

        <HomeNews currentIndex={currentIndex} 
        setCurrentIndex={setCurrentIndex}/>
        <HomeMembership />
        <section id="membership-inquiry">
        <HomeMembershipForm />
        </section>

        <section id="events-inquiry">
          <HomeEvents />
        </section>
      <AboutUs />
      {/* <Ads /> */}
    </>
  );
}

export default Index;